import React, { useEffect, useState } from "react";
import FormikControl from "../../../../components/FormikControls/FormikControl";
import {
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { Formik, Form } from "formik";
import { editIndexManagingSchema } from "../../StaticData/index";
import MultiSelect from "../../../../components/FormikControls/MultiSelect/MultiSelect";
import { useSelector } from "react-redux";
import AccordionLyt from "../../../../components/Layouts/AccordionLyt/AccordionLyt";
import { CreateIndexManagingFace, EditIndexManagingFace } from "../../Interfaces/Interfaces";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import DyLoadingCircular from "../../../../components/GlobalComponents/DyLoadingCircular/DyLoadingCircular";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
import {
  useGetAllObjectiveDefinitionLevelByTenantId,
  useGetAllObjectiveOKRStateByTenantId,
  useEditIndexManaging,
  useGetBAUDetail,
  useGetAllReportingPeriodByTenantId,
  useGetAllMeasurementUnitByTenantId
} from "../../Hooks/Index";
import {
  useGetAllStrategies
} from "../../../MissionAndStrategy/Hooks/index";
import {
  useGetAllPersonIndexByTenantId,
  useGetAllTenantIndexByTenantId,
  useGetAllActivePersonByTenantId
} from "../../../OKRManagment/Hooks/index";

const EditIndexManaging = ({
  periodsData,
  onSuccess,
  bauData,
  perId,
  setShowToastMessage2,
  setObjectiveAsyncOpState,
  afterSuccess,
  id,
  access,
  onClose
}: any) => {
  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  // const{data} : any = access  || {};
  // const{check} : any = data  || {};
  const [showAdvanceOptions, setShowAdvanceOptions] = useState<boolean>(false);
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  const [periodIdd, setPeriodId] = useState<any>();
  const [def, setDef] = useState<string>('');
  const [objNameIds, setObjNameIds] = useState<any>({
    tenantId: tenantId,
    // periodId: periodId,
    definitionLevelId: null,
  });
  const [editTeamsinintialValues, setEditTeamsInitialValues] =
  useState<any>(null);
  const {data:tenantIndexOptions,isLoading:gettenantIndexLoading}=useGetAllTenantIndexByTenantId(tenantId);
  const {data:strategiesOptions,isLoading:getstrategyDataLoading}=useGetAllStrategies(tenantId,periodIdd);
  const {data:personIndexOptions,isLoading:getMyIndexLoading}=useGetAllPersonIndexByTenantId(tenantId);
  const {data:reportingPeriodData,isLoading:reportingPeriodDataLoading}=useGetAllReportingPeriodByTenantId(tenantId);
  const {data:measurementUnitData,isLoading:measurementUnitDataLoading}=useGetAllMeasurementUnitByTenantId(tenantId);
  const {data:krRowData}=useGetBAUDetail(id);
  const {
    mutate: addObjective,
    data: addObjectiveData,
  } = useEditIndexManaging();
  // const[strategyData,setStrategyData]=useState([])
  // useEffect(() => {
  //   if(strategiesOptions !== null && strategiesOptions !== undefined ){
  //     setStrategyData(strategiesOptions?.map((item:any)=>{
  //       let{name,id}=item;
  //       return {year:id,title:name}
  //     }))
  //   }
  // }, [strategiesOptions]);
  const[strategyData,setStrategyData]=useState(null);
  useEffect(() => {
    // if(strategiesOptions !== null && strategiesOptions !== undefined ){
    //   setStrategyData(strategiesOptions?.map((item:any)=>{
    //     let{name,id}=item;
    //     return {year:id,title:name}
    //   }))
    // }
    if (strategiesOptions) {
      setStrategyData(strategiesOptions.map(({ name, id }: any,i:number) => {
        return { key:  (i+1) + "." + name + "      ", value: id };
      }));
    }
  }, [strategiesOptions]);
  const [periodOptions, setPeriodOptions] = useState<any>([]);
  const { data: submitOptions } =
  useGetAllObjectiveOKRStateByTenantId(tenantId);
  const { data: teamsOptions, isLoading: teamOPloading } =
  useGetAllObjectiveDefinitionLevelByTenantId(tenantId);
const { data: personsOptionds } = useGetAllActivePersonByTenantId(tenantId);
  const [okrStateId, setOkrStateId] = useState<string>("");
  const [indexId, setIndexId] = useState<any>();
  // const [measurementUnit, setmeasurementUnit] = useState<any>();
  const [teamId, setTeamId] = useState<any>();
  const [indexIdt, setIndexIdt] = useState<any>();
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
  const [addObjError, setAddObjError] = useState<any>(null);
  const[personIdData,setPersonIdData]=useState([])
  const[personIdData1,setPersonIdData1]=useState<any>([]);
  const [indxsId, setIndxsId] = useState<any>();
  const [disValue, setDisValue] = useState<any>();
  const [teamName, setTeamName] = useState<any>({
    teamName: null,
  });
  const[teamPersons,setTeamPersons]=useState<any[]>([]);

  const parentTypeData = [
    { key: "استراتژی", value: "Strategy" },
    { key: "شاخص", value: "Index" },
    { key: "ندارد", value: "None" },
  ];

  const parentTypeData1 = [
    { key: "شاخص", value: "Index" },
    { key: "ندارد", value: "None" },
  ];

  const[repoData,setRepoData]=useState([])
  useEffect(() => {
    if(reportingPeriodData !== null && reportingPeriodData !== undefined ){
    //  var t = reportingPeriodData?.map((item:any)=>{
    //     let{key,value}=item;
    //     return {year:value,title:key}
    //   })
      setRepoData(reportingPeriodData);
    }
  }, [reportingPeriodData]);

  const[measData,setMeasData]=useState([])
  useEffect(() => {
    if(measurementUnitData !== null && measurementUnitData !== undefined ){
      setMeasData(measurementUnitData);
    }
  }, [measurementUnitData]);

  useEffect(() => {
    if(personIdData1 !== null && personIdData1 !== undefined ){
      setPersonIdData(personIdData1?.data?.map((item:any)=>{
        let{name,id}=item;
        return {year:id,title:name}
      }))
    }
  }, [personIdData1]);

  const[indexData,setIndexData]=useState([])
   useEffect(() => {
    if(bauData !== null && bauData !== undefined ){
      var o = bauData?.map((item:any)=>{
        let{id,name}=item;
        return {year:id,title:name}
      })
      setIndexData(o);
    }
  }, [bauData]);

  useEffect(() => {
    if (addObjectiveData) {
      if (addObjectiveData?.data.isSuccess) {
        onClose(false);
        onSuccess();
        setShowToastMessage2(true);
        SetIsSuccess(true);
        SetTMessage(addObjectiveData?.data.metaData.message);
      } else {
        setShowLtoastMessage(true);
        SetIsSuccess(false);
        SetTMessage(addObjectiveData?.data.metaData.message);
        setAddObjError(addObjectiveData?.data);
      }
    }
  }, [addObjectiveData]);
  const [reportingPeriod, setreportingPeriod] = useState<any>();
  const [measurementUnit, setmeasurementUnit] = useState<any>();
  useEffect(() => {
    if (krRowData) {
      let {
        description,
        periodId,
        responsibleId,
        teamId,
        measurementUnitId,
        reportingPeriodId,
        applyInPeriods,
        source ,
        displayPriority,
        nameType ,
        tenantId,
        lowerLimit,
        indexId,
        startValue,
        upperLimit,
        parentType,
        parentId,
        parentIds,
        parents,
        team,
        targetValue,
        id
      }: any = krRowData;
      let en = {
        description : description ,
        periodId : periodId,
        responsibleId : responsibleId,
        teamId : teamId,
        measurementUnitId : measurementUnitId,
        reportingPeriodId : reportingPeriodId,
        applyInPeriods : applyInPeriods,
        source : source,
        nameType : nameType ,
        displayPriority:displayPriority,
        tenantId : tenantId,
        lowerLimit : lowerLimit,
        indexId : indexId,
        team:team,
        startValue : startValue,
        upperLimit : upperLimit,
        parentType : parentType,
        parentId : parentId,
        parentIds : parentIds,
        parents : parents,
        targetValue : targetValue,
        id : id
      };
      setTeamPersons(parents?.map((item:any)=>{
        let{id:year,name:title}=item;
        return{year,title}
       }))

       setmeasurementUnit(en?.measurementUnitId);
       setreportingPeriod(en?.reportingPeriodId);
       setDef(en?.team);
       setEditTeamsInitialValues(en);
    }
  }, [krRowData]);

  const[da,setDa]=useState<any>(null);
 
  const initialAddObjective = async (data: any) => {
   await addObjective(da);
  };

  useEffect(() => {
    if(periodsData){
      let transformed = periodsData?.map((item: any) => {
        let { name: key, id: value } = item;
        return { key, value };
      });
      setPeriodOptions(transformed);
    }
  }, []);

  return (
    <>
      <Box width={"100%"} maxHeight={"50em"}>
        <Formik
          enableReinitialize
          initialValues={{...editTeamsinintialValues 
            // , reportingPeriodId : reportingPeriod
            // , measurementUnitId : measurementUnit
            , oKRStateId: okrStateId
          }}
          validationSchema={editIndexManagingSchema}
          validate={(data) => {
            let{startValue, id,source,lowerLimit,indexId,nameType /*,reportingPeriodId,
              measurementUnitId*/,upperLimit,parentType,parentId,targetValue,parents,teamId,responsibleId,
              periodId , description,parentIds
            } : any = data;
            let en = {
              description : description ,
              periodId : periodId,
              responsibleId : responsibleId,
              teamId : teamId,
              measurementUnitId : measurementUnit,
              reportingPeriodId : reportingPeriod,
              source : source,
              nameType : nameType ,
              tenantId : tenantId,
              lowerLimit : lowerLimit,
              okrStateId:okrStateId,
              indexId : indexId,
              startValue : startValue,
              upperLimit : upperLimit,
              parentType : parentType,
              parentId : parentId,
              parentIds : indxsId === null || indxsId === undefined ? parentIds : indxsId,
              parents : parents,
              targetValue : targetValue,
              id : id,
              displayPriority:disValue
            };
            setDa(en);
          }}
          
          onSubmit={(data) => {
            initialAddObjective(data);
          }}
        >
          {({
            values,
            setFieldValue,
            dirty,
            isValid,
            touched,
            errors,
            setFieldTouched,
            handleChange,
          }: any) => (
            <Form>
              <Grid container>

                <Grid item xs={12} md={12} >
                    <div className="h-11 w-full flex gap-x-8 items-center">
                    <label className="flex gap-x-2 w-2/6 items-center">
                          <input
                            type="radio"
                            className="radio radio-xs"
                            name="useTenantList"
                            value="useTenantList"
                            id="useTenantList"
                            onChange={() =>
                              setFieldValue(
                                "nameType",
                                "useTenantList"
                              )
                            }
                            checked={
                              values?.nameType === "useTenantList"
                            }
                          />
                          <span className=" text-xs">لیست شرکت</span>
                        </label>
                        <label className="flex gap-x-2 items-center w-2/6">
                          <input
                            type="radio"
                            className="radio radio-xs"
                            name="useMyList"
                            value="useMyList"
                            id="useMyList"
                            onChange={() =>
                              setFieldValue(
                                "nameType",
                                "useMyList"
                              )
                            }
                            checked={
                              values?.nameType ===
                              "useMyList"
                            }
                          />
                          <span className=" text-xs">
                            لیست من
                          </span>
                        </label>
                        <div className="w-3/6">
                        {values?.nameType === "useTenantList" ? 
                            <div className=" relative cursor-pointer ">
                            <Grid item xs={12} md={12}>
                            {tenantIndexOptions && (
                            <FormikControl
                                        control='select'
                                        options={tenantIndexOptions||[]}
                                        isLoading={gettenantIndexLoading}
                                        label="انتخاب شاخص از لیست شرکت "
                                        name='indexId'
                                        fullWidth
                                        value={values?.indexId}
                                        //defaultValue={values?.indexId}
                                        onChange={(e: any, other: any) => {
                                          let { target } = e;
                                          let { value } = target;
                                          setFieldValue("indexId", value);
                                          setIndexId(value);
                                          setIndexIdt("useTenantList")
                                        }}
                                    />
                                      )}
                            </Grid>
                            </div>
                          : values?.nameType === "useMyList" ? 
                            <div className=" relative cursor-pointer ">
                            <Grid item xs={12} md={12}>
                            {personIndexOptions && (
                            <FormikControl
                                        control='select'
                                        options={personIndexOptions||[]}
                                        isLoading={getMyIndexLoading}
                                        label="انتخاب شاخص از لیست من"
                                        name='indexId'
                                        fullWidth
                                        value={values?.indexId}
                                        //defaultValue={values?.indexId}
                                        onChange={(e: any, other: any) => {
                                          let { target } = e;
                                          let { value } = target;
                                          setFieldValue(
                                            "nameType",
                                            "useMyList"
                                          )
                                          setIndexId(value);
                                          setFieldValue("indexId", value);
                                          setIndexIdt("useMyList")
                                        }}
                                    />
                                      )}
                            </Grid>
                            </div>
                        :<></> }
                        </div>
                    </div>
                </Grid>
                    
                <Grid item xs={12} md={4} mt={1}>
                  <Box padding={"8px"}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="demo-simple-select-label">سطح</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-selectd"
                        value={values?.teamId || ""}
                        label="سطح"
                        onChange={(e: any, other: any) => {
                          let { props } = other;
                          let {children} = props;
                          setTeamName(children);
                          let { target } = e;
                          let { value } = target;
                          setTeamId(value);
                          setFieldValue("teamId", value);
                        }}
                      >
                        {teamOPloading && (
                          <Box width={"100%"} textAlign={"center"}>
                            <DyLoadingCircular />
                          </Box>
                        )}

                        {teamsOptions &&
                          teamsOptions.map((item: any) => {
                            let { key, value, isCompany } = item;
                            return (
                              <MenuItem
                                key={key}
                                value={value}
                                content={isCompany}
                              >
                                {key}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} md={4} mt={1}>
                  <Box sx={{ padding: "8px" }}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        دوره زمانی
                      </InputLabel>
                      <Select
                        defaultValue={perId}
                        size="small"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={values?.periodId || ""}
                        label="دوره زمانی"
                        onChange={({ target }: any) => {
                          let { value } = target;
                          setFieldValue("periodId", value);
                          setPeriodId(value);
                          setObjNameIds((prev: any) => ({
                            ...prev,
                            periodId: value,
                          }));
                        }}
                      >
                        {periodOptions.map((item: any, i: number) => {
                          let { key, value, desc } = item;
                          return (
                            <MenuItem
                              key={i}
                              sx={{
                                fontSize: "0.7rem",
                                bgcolor: "transparent",
                              }}
                              value={value}
                            >
                              {key}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} md={4} mt={1}>
                  <FormikControl
                    control="select"
                    options={personsOptionds || []}
                    label="مسئول"
                    name="responsibleId"
                    fullWidth
                    value={values?.responsibleId || ""}
                    onChange={({ target }: any) => {
                      let { value } = target;
                      setFieldValue("responsibleId", value);
                    }}
                  />
                </Grid>
                
                <Grid item xs={12} md={12}>
                              <FormikControl
                                control="select"
                                type="select"
                                label="نوع والد "
                                value={values?.parentType || ""}
                                options={teamName === 'شرکت' || def === 'شرکت' ? parentTypeData : parentTypeData1}
                                name="parentType"
                                fullWidth
                                onChange={({ target }: any) => {
                                  let { value } = target;
                                  setFieldValue("parentType", value);
                                }}
                              />
                </Grid>

                <Grid item xs={12} md={12}>
                <Grid item xs={12} md={12}>
                <div >
                        {values?.parentType === "Strategy" ? 
                            <div className=" relative cursor-pointer ">
                               <Grid item xs={12} md={6} >
                                  <div className='error'>
                                  {/* <ErrorMessage name="categoryIds" /> */}
                                  </div>
                                  <FormikControl
                                      control="select"
                                      options={strategyData || []}
                                      // options={strategiesOptions || []}
                                      isLoading={getstrategyDataLoading}
                                      // onChangee={setFieldValue}
                                      fullWidth
                                      value={values?.parentIds || ""}
                                      name='parentIds'
                                      label="انتخاب استراتژی"
                                      onChange={(e: any, other: any) => {
                                        let { target } = e;
                                        let { value } = target;
                                        // let myList: string[] = [];
                                        // myList.push(value)
                                        // setSelectedRowData(myList);
                                        setFieldValue("parentIds", value);
                                        setIndxsId(value);
                                      }}
                                    />
                              </Grid>        
                           
                            </div>
                            :
                            <div className=" relative cursor-pointer ">
                            </div>
                        }
                        </div>
                </Grid>
                <Grid item xs={12} md={12}>
                <div >
                        { values?.parentType === "Index" ? 
                            <div className=" relative cursor-pointer ">
                               <Grid item xs={12} md={6} >
                                  <div className='error'>
                                  </div>
                                  <MultiSelect
                                   initialValues={teamPersons || []}
                                    options={indexData || []}
                                    isLoading={gettenantIndexLoading}
                                    onChangee={setFieldValue}
                                    propName='parentId'
                                    label="انتخاب شاخص"
                                  />
                              </Grid>        
                            
                            </div>
                            :
                            <div className=" relative cursor-pointer ">
                            </div>
                        }
                        </div>
                </Grid>
                </Grid>

                <Grid item xs={12} md={4} >
                 <TextField
                    // control="textField"
                    label="شروع"
                    name="startValue"
                    fullWidth
                    value={values?.startValue || ""}
                    type={"number"}
                    onChange={({ target }: any) => {
                      let { value } = target;
                      setFieldValue("startValue", value);
                    }}
                  />
                </Grid>
  
                <Grid item xs={12} md={4} sx={{
                      padding: '0px 8px', // پدینگ مشابه TextField
                    }} >
                    <TextField
                    // control="textField"
                    label="حد پایین"
                    name="lowerLimit"
                    fullWidth
                    value={values?.lowerLimit || ""}
                    type={"number"}
                    onChange={({ target }: any) => {
                      let { value } = target;
                      setFieldValue("lowerLimit", value);
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    // control="textField"
                    label="حد بالا"
                    name="upperLimit"
                    fullWidth
                    value={values?.upperLimit || ""}
                    type={"number"}
                    onChange={({ target }: any) => {
                      let { value } = target;
                      setFieldValue("upperLimit", value);
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6} mt={1}>
                              <FormikControl
                                control="select"
                                label="واحد سنجش"
                                isLoading={measurementUnitDataLoading}
                                options={measData || {}}
                                name="measurementUnitId"
                                value={values?.measurementUnitId || ""}
                                onChange={(e: any, other: any) => {
                                  let { target } = e;
                                  let { value } = target;
                                  setmeasurementUnit(value);
                                  setFieldValue("measurementUnitId", value);
                                }}
                                fullWidth
                              />

                            </Grid>
                            {/* <Grid item xs={12} md={6} mt={1}>
                              <FormikControl
                                control="select"
                                isLoading={reportingPeriodDataLoading}
                                options={repoData || {}}
                                label="منطق گزارش دهی"
                                name="reportingPeriodId"
                                value={values?.reportingPeriodId || ""}
                                onChange={(e: any, other: any) => {
                                  let { target } = e;
                                  let { value } = target;
                                  setreportingPeriod(value);
                                  setFieldValue("reportingPeriodId", value);
                                }}
                                fullWidth
                              />
                </Grid> */}

                    <Grid item xs={12} md={6}>
                     <Box sx={{ padding: "15px" }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                        منطق گزارش دهی {" "}
                        </InputLabel>
                        <Select
                          sx={{
                            "& .muirtl-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select":
                              { py: "7px" },
                          }}
                          size="small"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={values?.reportingPeriodId || ""}
                            label="منطق گزارش دهی "
                          onChange={({ target }: any) => {
                            let { value } = target;
                            setreportingPeriod(value);
                            setFieldValue("reportingPeriodId", value);
                          }}
                        >
                          {repoData.map((item: any, i: number) => {
                            let { key, value, desc } = item;
                            return (
                              <MenuItem
                                key={i}
                                sx={{
                                  fontSize: "0.7rem",
                                  bgcolor: "transparent",
                                }}
                                value={value}
                              >
                                {key}
                                {"\u00A0"}
                                <Typography fontSize={"0.5rem"}>
                                  {desc}
                                </Typography>
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                     </Box>
                    </Grid>
                
                <div className="w-full ">
                  <AccordionLyt
                     collapse={setShowAdvanceOptions}
                     title={" تنظیمات پیشرفته (اختیاری)"} 
                     expanded={showAdvanceOptions} 
                   > 
                     <Grid item xs={12} md={12}>
                <Grid item xs={12} md={6}>
                  <FormikControl
                    control="textField"
                    type="text"
                    label="عدد مورد انتظار (تارگت)"
                    name="targetValue"
                    fullWidth
                    values={values?.targetValue || ""}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                        <Box sx={{ padding: "8px", fontSize: 10 }}>
                        <TextField
                        sx={{ fontSize: 10 }}
                        size="small"
                        type="number" // نوع فیلد را به عدد تغییر دادیم
                        label="اولویت نمایش" // عنوان فیلد
                        name="displayPriority" // نام فیلد
                        fullWidth
                        value={values?.displayPriority || ""} // مقدار فیلد
                        onChange={({ target }: any) => {
                        let { value } = target;
                        setFieldValue("displayPriority", value); 
                        setDisValue(value);// به‌روزرسانی مقدار فیلد
                        }}
                        />
                        </Box>
                        </Grid>
                        </Grid>
                    <Grid container>
                    <Grid item xs={12} md={12}>
                        <Box sx={{ padding: "8px" }}>
                          <TextField
                            size="small"
                            label="منبع"
                            name="source"
                            fullWidth
                            value={values?.source}
                            onChange={({ target }: any) => {
                              let { value } = target;
                              setFieldValue("source", value);
                            }}
                          />
                        </Box>
                      </Grid>
                     
                      <Grid item xs={12} md={12}>
                        <Box sx={{ padding: "8px" }}>
                          <TextField
                            size="small"
                            label="توضیحات"
                            name="description"
                            fullWidth
                            value={values?.description}
                            onChange={({ target }: any) => {
                              let { value } = target;
                              setFieldValue("description", value);
                            }}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={12}>
                      {/* <div className="h-11 w-full flex  items-center">
                       { check && (<label className="flex gap-x-2 items-center w-2/6">
                          <input
                            type="checkbox"
                            className="checkbox checkbox"
                            name="AddToTenantList"
                            value="AddToTenantList"
                            id="AddToTenantList"
                            defaultChecked = {true}
                            onChange={() =>
                              values?.AddToTenantList ===
                              true ? setFieldValue(
                                "AddToTenantList",
                                false
                              ) :
                              setFieldValue(
                                "AddToTenantList",
                                true
                              )
                            }
                            checked={
                              values?.AddToTenantList ===
                              true
                            }
                          />
                          <span className="text-md-xs ">
                            به لیست شرکت اضافه شود
                          </span>
                      </label>)}

                      </div> */}
                      </Grid>
                    </Grid>
                  </AccordionLyt>
                </div>

                <Grid item xs={12} md={12} mt={3}>
                  <Box
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"end"}
                    flexDirection={"row-reverse"}
                    columnGap={2}
                  >
                    {submitOptions &&
                      submitOptions?.map((item: any, i: number) => {
                        let { label, id } = item;
                        return (
                          <Box width={"20%"}>
                            <DyButton
                              disabled={false}
                              key={i}
                              type={"submit"}
                              variant={"contained"}
                              bgColor={"info"}
                              caption={label}
                              onClick={() => {
                                setOkrStateId(id);
                              }}
                            />
                          </Box>
                        );
                      })}
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>

        {showLtoastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )}
      </Box>
    </>
  );
};

export default EditIndexManaging;